module.exports = __webpack_public_path__ + "fonts/payback_bold-webfont.dcc3d711.eot";